// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonLink_button__Coqfb","label":"buttonLink_label__J3HV_","icon":"buttonLink_icon__1Pdlv","chevron":"buttonLink_chevron__1IJRD"};